import React, {ReactNode} from 'react';

interface ErrorBoundaryProps {
	children: ReactNode;
	onError(error: Error): void;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
	componentDidCatch(error: Error) {
		this.props.onError(error);
	}

	render() {
		return this.props.children;
	}
}
